import {Fragment, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {MGateWayService} from '../../../lich-su-truyen-nhan/MGateWayService';
import {ToastService} from '../../../../AppToast';
import {ConfirmDialogService} from '../../../../AppConfirmDialog';

import {TransferLogs} from '../../../lich-su-truyen-nhan/component/TransferLogs';

export const DialogViewTransferLog = (props) => {

  const type = 'Declare';

  const {display, setDisplay, selectedItem} = props;

  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);

  const rollbackStatus = () => {
    ConfirmDialogService.confirm('Xác nhận', 'Bạn có thực sự muốn khôi phục trạng thái Tờ khai đăng ký về Chờ ký để gửi lại CQT không?', () => {
      MGateWayService.rollbackStatus(type, [selectedItem.id]).then(data => {
        setVersion(Date.now());
        ToastService.success('Khôi phục thành công');
      });
    });
  }

  const getResult = () => {
    MGateWayService.getResult(selectedItem.id, type).then(() => {
      setVersion(Date.now());
      ToastService.success('Tải lại thành công');
    });
  }

  return (
    <Dialog header="Lịch sử truyền nhận" visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
      {selectedItem &&
				<Fragment>
					<p><b>Tờ khai đăng ký</b></p>
					<TransferLogs type={type} invoice={selectedItem} rows={20} heightCalc={200} idAction={selectedItem.id} version={version}
												setCanRollback={setCanRollback}/>
				</Fragment>
      }

      <div className="flex justify-content-end mt-2">
        {canRollback &&
					<Button label="Khôi phục trạng thái" className="p-button-outlined p-button-sm mr-2" onClick={rollbackStatus}/>
        }
        <Button label="Kiểm tra" className="p-button-outlined p-button-sm mr-2" onClick={getResult}/>
        <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm"/>
      </div>
    </Dialog>
  );
}